import React from 'react';
import ControlBoard from '../../components/ControlBoard';
import Tabs from '../../components/Tabs';
import AutoHandle from './AutoHandle';
// import Label from '../../components/Label';

const TabPane = Tabs.TabPane;

export default function CardController(props) {
  const { headingLabel, toggleCardController } = props;
  const handleTabClick = (index) => () => {

  };

  return (
    <ControlBoard headingLabel={headingLabel} doneText="Finish" showCancel={false} onDone={() => toggleCardController(false)}>
      <div style={{ position: 'relative' }}>
        <Tabs intialActiveTab={2}>
          <TabPane title="Custom" tabKey={1} onClick={handleTabClick}>
            <div style={{paddingTop: 10}}>Tab 1</div>
          </TabPane>
          <TabPane title="Auto" tabKey={2} onClick={handleTabClick}>
            <AutoHandle />
          </TabPane>
        </Tabs>
      </div>
    </ControlBoard>
  );
}
